export const DonateIframe = () => {
  return (
    <div className="donate">
      <iframe
        src="https://donate.kindlink.com/ABU-HANEEFA-EDUCATIONAL-TRUST/4646"
        scrolling="no"
        title="Donate"
      >
        <p>Your browser does not support iframes.</p>
      </iframe>
    </div>
  );
};
